// test2585
(2585 && 0);
